import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { FiArrowUpRight } from 'react-icons/fi';
import SEO from '../components/SEO';

const Businesses = () => {
  const verticals = [
    { title: 'Arvaron Sourcing', subtitle: 'Sourcing & Procurement', description: 'Strategic global sourcing solutions connecting markets, ensuring quality, and optimizing cost structures across industries.', image: 'https://images.pexels.com/photos/5860937/pexels-photo-5860937.jpeg', path: '/business/sourcing' },
    { title: 'Arvaron Logistics', subtitle: 'Logistics & Supply Chain', description: 'End-to-end global freight, warehousing, and distribution networks engineered for resilience and efficiency.', image: 'https://images.unsplash.com/photo-1653794280510-6d0c380449a7', path: '/business/logistics' },
    { title: 'Arvaron Exports', subtitle: 'Imports & Exports', description: 'Facilitating seamless international trade with deep EXIM expertise, trade finance, and cross-border commerce solutions.', image: 'https://images.pexels.com/photos/9806482/pexels-photo-9806482.jpeg', path: '/business/exports' },
    { title: 'Arvaron Technologies', subtitle: 'IT Consulting & Software', description: 'Driving digital transformation through custom software development, IT consulting, and cloud innovation for enterprises.', image: 'https://images.unsplash.com/photo-1499951360447-b19be8fe80f5', path: '/business/technologies' },
    { title: 'Arvaron Digital', subtitle: 'Digital Marketing', description: 'Data-driven marketing technology, brand strategy, and performance campaigns for the modern enterprise.', image: 'https://images.unsplash.com/photo-1718220216044-006f43e3a9b1', path: '/business/digital' },
    { title: 'Arvaron Infra', subtitle: 'Real Estate', description: 'Development and management of landmark commercial and residential properties across India\'s fastest-growing markets.', image: 'https://images.unsplash.com/photo-1527576539890-dfa815648363', path: '/business/infra' },
    { title: 'Arvaron Retail', subtitle: 'Retail', description: 'Curated retail experiences and brand distribution connecting consumers with quality products across India and beyond.', image: 'https://images.pexels.com/photos/35782401/pexels-photo-35782401.jpeg', path: '/business/retail' }
  ];

  return (
    <div className="bg-black text-white" data-testid="businesses-page">
      <SEO title="Our Businesses" description="Seven distinct business verticals building India's next generation conglomerate." url="/businesses" />
      <section className="relative h-[50vh] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 z-0 bg-gradient-to-b from-[#0a0a0a] to-black" />
        <div className="absolute inset-0 hero-overlay" />
        
        <div className="max-w-7xl mx-auto px-6 lg:px-8 z-10 text-center">
          <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
            <p className="text-xs uppercase tracking-[0.3em] text-[#17B9BE] mb-6">Our Businesses</p>
            <h1 className="font-display text-5xl md:text-7xl font-bold mb-6" data-testid="businesses-title">
              Our Business <span className="brand-gradient-text">Verticals</span>
            </h1>
            <p className="text-lg text-white/50 max-w-3xl mx-auto">
              Seven distinct verticals, one unified vision — building India's next generation conglomerate
            </p>
          </motion.div>
        </div>
      </section>

      <section className="py-24 bg-black">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {verticals.map((vertical, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.08 }}
                viewport={{ once: true }}
                data-testid={`business-card-${index}`}
              >
                <Link
                  to={vertical.path}
                  className="group block bg-[#0a0a0a] rounded overflow-hidden border border-white/5 hover:border-[#17B9BE]/20 transition-all duration-300 gradient-border"
                >
                  <div className="relative h-56 overflow-hidden">
                    <img
                      src={vertical.image}
                      alt={vertical.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-black/40 to-transparent" />
                  </div>
                  <div className="p-6">
                    <p className="text-xs uppercase tracking-[0.15em] text-[#17B9BE] mb-2">{vertical.subtitle}</p>
                    <h3 className="text-xl font-bold mb-3">{vertical.title}</h3>
                    <p className="text-white/40 text-sm mb-5 leading-relaxed">{vertical.description}</p>
                    <div className="flex items-center text-white/40 group-hover:text-[#17B9BE] transition-colors">
                      <span className="text-xs uppercase tracking-wider font-medium">Explore</span>
                      <FiArrowUpRight className="ml-2 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
                    </div>
                  </div>
                </Link>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Businesses;
